import './LoginPage.css';
import React from 'react';

function TermsPage() {
  return (
    <div className="App container" dir="rtl">
      <img src="logo.jpeg" alt="الشعار" id='logo' height={100} width={100} />
      <h2 className="login-title">الشروط والأحكام</h2>
      
      <div className="terms-content" style={{ textAlign: 'right', padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
        
        <div className="terms-section" style={{ marginBottom: '30px', backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
          <h4 style={{ color: '#8b2881', marginBottom: '15px' }}>📱 عن الخدمة</h4>
          <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
            هذا الموقع مخصص لتعبئات <strong>إنوي (inwi)</strong> فقط.
          </p>
        </div>

        <div className="terms-section" style={{ marginBottom: '30px', backgroundColor: '#fff3cd', padding: '20px', borderRadius: '8px', border: '2px solid #ffc107' }}>
          <h4 style={{ color: '#8b2881', marginBottom: '15px' }}>⚠️ تحذير مهم - لا يمكن الإرجاع</h4>
          <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#856404' }}>
            <strong>في حالة إتمام التعبئة بنجاح، لا يمكن إرجاعها أو استرداد المبلغ.</strong>
          </p>
          <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#856404' }}>
            لا يوجد تعويض. يرجى التأكد جيداً من:
          </p>
          <ul style={{ fontSize: '16px', lineHeight: '1.8', color: '#856404' }}>
            <li>الرقم الذي ستقوم بإرسال التعبئة إليه</li>
            <li>العرض المختار (*6، *3...إلخ)</li>
            <li>المبلغ المطلوب</li>
          </ul>
        </div>

        <div className="terms-section" style={{ marginBottom: '30px', backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
          <h4 style={{ color: '#8b2881', marginBottom: '15px' }}>📵 ملاحظة حول بعض الأرقام</h4>
          <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
            هناك بعض الأرقام التي قد لا تقبل التعبئة بهذه الطريقة. في حالة فشل التعبئة، سيتم إرسالها عبر طريقة بديلة.
          </p>
        </div>

        <div className="terms-section" style={{ marginBottom: '30px', backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
          <h4 style={{ color: '#8b2881', marginBottom: '15px' }}>💰 نسبة الربح</h4>
          <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
            نسبة الربح المضافة هي <strong>10%</strong> على جميع التعبئات.
          </p>
        </div>

        <div className="terms-section" style={{ marginBottom: '30px', backgroundColor: '#e7f3ff', padding: '20px', borderRadius: '8px', border: '2px solid #0d6efd' }}>
          <h4 style={{ color: '#8b2881', marginBottom: '15px' }}>🏦 طرق الدفع المتاحة</h4>
          <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
            يمكنك الإرسال إلى أي من البنوك التالية (اختر الأقرب إليك):
          </p>
          <ul style={{ fontSize: '16px', lineHeight: '1.8' }}>
            <li>💳 <strong>بريد بنك</strong> (Barid Bank)</li>
            <li>💳 <strong>البنك التجاري وفا بنك</strong> (Attijariwafa Bank)</li>
            <li>💳 <strong>سي آي إتش بنك</strong> (CIH Bank)</li>
            <li>💳 <strong>البنك الشعبي</strong> (Banque Populaire)</li>
            <li>💳 <strong>وفا بنك</strong> (Wafabank)</li>
          </ul>
        </div>

        <div className="terms-section" style={{ marginBottom: '30px', backgroundColor: '#d4edda', padding: '20px', borderRadius: '8px', border: '2px solid #28a745' }}>
          <h4 style={{ color: '#8b2881', marginBottom: '15px' }}>✅ بالمتابعة، أنت توافق على</h4>
          <ul style={{ fontSize: '16px', lineHeight: '1.8' }}>
            <li>أنك قرأت وفهمت جميع الشروط المذكورة أعلاه</li>
            <li>أنك تتحمل مسؤولية التأكد من صحة البيانات المدخلة</li>
            <li>أنك تقبل عدم إمكانية إرجاع التعبئة بعد إتمامها</li>
            <li>أنك على علم بنسبة الربح المضافة 10%</li>
          </ul>
        </div>

        <div className="d-grid gap-2" style={{ marginTop: '30px' }}>
          <a href="/register" className="btn btn-primary" id='login' style={{ fontSize: '18px', padding: '12px' }}>
            ← العودة للتسجيل
          </a>
          <a href="/login" className="btn btn-outline-primary" style={{ fontSize: '18px', padding: '12px' }}>
            ← لديك حساب؟ تسجيل الدخول
          </a>
        </div>

      </div>
      <br />
    </div>
  );
}

export default TermsPage;
